<template>
    <div class="d-flex menu-element">
        <b-dropdown
            v-if="['vigilante'].includes(currentProfile.slug) && guardNotifications.length > 0"
            ref="notificationsDropdown"
            size="lg"
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
            class="position-relative mr-3 mt-1"
        >
            <template #button-content class="bg-light text-primary cursor-pointer">
                <i class="far fa-bell"></i><span class="badge rounded-pill bg-danger top-0 position-absolute"> {{ guardNotifications.length }} </span>
            </template>

            <b-dropdown-group
                v-for="notification in guardNotifications"
                :value="notification"
                :key="notification.id"
                id="dropdown-group-1"
                @click="goToNotification(notification.route, notification.id)"
                :header="notification.title"
            >
                <b-dropdown-text style="cursor: pointer; width: 240px">{{ notification.body.substring(0, 100) }}</b-dropdown-text>
            </b-dropdown-group>
        </b-dropdown>
        <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" class="bg-light text-primary">
            <!-- <template #button-content class="bg-light text-primary">
                <span class="btn btn-secondary bg-light text-primary border-0 menu-element">  <i class="fas fa-user"></i>&nbsp;{{ currentUser.name }} </span>
            </template> -->
            <template #button-content class="bg-light text-primary">
                <div class="user-avatar" v-if="currentUser.photo_url" :style="{ 'background-image': `url(${currentUser.photo_url})` }"></div>
                <span class="btn btn-secondary bg-light text-primary border-0 menu-element" v-else>
                    <i class="fas fa-user"></i>
                </span>
                <span class="user-name">{{ currentUser.name }}</span>
            </template>
            <b-dropdown-item-button @click="$emit('profile')">
                <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>&nbsp;Mi Perfil
            </b-dropdown-item-button>
            <b-dropdown-item-button v-if="isGuard" @click="$router.push({ name: 'guardIndicators' })">
                <i class="fas fa-chart-line fa-sm fa-fw mr-2 text-gray-400"></i>&nbsp;Indicadores
            </b-dropdown-item-button>
            <b-dropdown-item-button v-if="['administrador', 'interno'].includes(currentProfile.slug)" @click="$router.push({ name: 'selectVenuePage' })">
                <i class="fas fa-retweet fa-sm fa-fw mr-2 text-gray-400"></i>&nbsp;Cambiar de sede
            </b-dropdown-item-button>
            <b-dropdown-item-button
                v-if="currentProfile.slug === 'administrador' || currentProfile.slug === 'administrativo'"
                @click="$router.push({ name: 'adminVideoTutorials' })"
            >
                <i class="fas fa-play fa-sm fa-fw mr-2 text-gray-400"></i>&nbsp;Videotutoriales
            </b-dropdown-item-button>
            <b-dropdown-item-button v-if="currentProfile.slug == 'interno'" @click="goToTutorial">
                <i class="fas fa-play fa-sm fa-fw mr-2 text-gray-400"></i>&nbsp;Ver Tutorial
            </b-dropdown-item-button>
            <b-dropdown-item-button v-if="isGuard" @click="releaseShift">
                <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>&nbsp;Entregar turno
            </b-dropdown-item-button>
            <b-dropdown-item-button @click="openSupportPage">
                <i class="fas fa-question fa-sm fa-fw mr-2 text-gray-400"></i>&nbsp;Soporte
            </b-dropdown-item-button>
            <b-dropdown-item-button v-if="currentProfile.slug == 'interno'" @click="onDeleteAccount">
                <i class="fas fa-trash fa-sm fa-fw mr-2 text-gray-400"></i>&nbsp;Eliminar cuenta
            </b-dropdown-item-button>
            <b-dropdown-item-button @click="$emit('logout')">
                <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>&nbsp;Salir
            </b-dropdown-item-button>
        </b-dropdown>
    </div>
</template>

<script>
import { SET_GUARD_NOTIFICATIONS } from '@store/_mutations'
import { mapGetters, mapMutations } from 'vuex'
export default {
    computed: {
    //...mapGetters(['currentShift']),
    ...mapGetters(
            {
                guardNotifications: 'guardNotifications',
                currentShift: 'currentShift'
            }
        ),
        isGuard() {
            return this.currentProfile.slug === 'vigilante'
        },
    },
    methods: {
        ...mapMutations({
            setGuardNotifications: SET_GUARD_NOTIFICATIONS,
        }),
        onAvatarClick() {
            $('.dropdown-toggle').dropdown('toggle')
        },
        releaseShift() {
            if (!this.currentShift) return
            this.$router.push({
                name: 'endShift',
                params: {
                    currentShiftId: this.currentShift.id,
                },
            })
        },
        goToTutorial() {
            window.open(`https://youtu.be/t66clohMrig`, '_blank')
        },

        openSupportPage() {
            this.$router.push({
                name: 'supportReport',
            })
        },
        async goToNotification(route, id) {
            try {
                const payload = {
                    currentUserId: this.currentUserId,
                    isRead: 1,
                }
                const { data } = await this.$repo.put(`notifications/${id}`, payload)

                const notifications = this.guardNotifications.filter((notification) => notification.id !== id)
                this.setGuardNotifications(notifications)
                this.$refs.notificationsDropdown.hide()

                // validate if the current route is the same as the notification route
                if (this.$route.name === route) return
                this.$router.push({ name: route })
            } catch (error) {
                toastr.error(error)
            }
            //limpiar el store de notificaciones
        },
        
        async onDeleteAccount(){
            try {
                const value = await this.$bvModal.msgBoxConfirm(`¡No queremos que te vayas! Pero si decides continuar con la eliminación de tu cuenta, ten en cuenta que no recibirás más notificaciones de la administración y la vigilancia. Para reactivar tu cuenta en el futuro, por favor, contacta a la administración.`, {
                    title: 'Confirmar eliminación de cuenta',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Confirmar',
                    cancelTitle: 'Cancelar',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                })
                if (value) {
                    const { data } = await this.$repo.post(`people/${this.currentPerson.id}/delete-account`)
                    if(data.message){
                        toastr.success('Cuenta eliminada satisfactoriamente')
                        this.$router.replace('/')
                    }
                }
            } catch (error) {
                toastr.error('Ocurrió un error al eliminar la cuenta, por favor intenta de nuevo más tarde')
            }
        }
    },
}
</script>

<style>
.menu-element {
    margin-top: -6px;
}
.user-avatar {
    display: inline-block;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    margin-right: 5px;
    vertical-align: middle;
}
.user-name {
    font-weight: 600;
    font-size: 0.85rem;
}
</style>
